import { createFileRoute } from '@tanstack/react-router';

import AirflowMonitorStage from '@/ui/pages/Installer/stages/airflow/AirflowMonitorStage';

// HS-1640: stage 5 — the AFA1000 monitor over Modbus, and the commissioning verification.
export const Route = createFileRoute(
  '/_dashboard/installer/installations/$id/airflow-monitor-test',
)({
  component: AirflowMonitorStage,
});
